import { type FC } from "react";

import { cn } from "@/shared/lib/utils";
import sarahImage from "@/shared/assets/team/Sarah.png";
import irinaImage from "@/shared/assets/team/irina.png";

interface SupportAvatarsProps {
  size?: "sm" | "md";
  showOnline?: boolean;
}

export const SupportAvatars: FC<SupportAvatarsProps> = ({ size = "sm", showOnline = false }) => {
  const avatarSize = size === "sm" ? "w-6 h-6" : "w-8 h-8";
  const overlap = size === "sm" ? "-ml-2" : "-ml-2.5";

  return (
    <div className="flex items-center mr-0.5">
      <div className="relative z-10">
        <div className={cn(avatarSize, "rounded-full overflow-hidden border-2 border-white")}>
          <img src={sarahImage} alt="Sarah" className="w-full h-full object-cover" />
        </div>
        {showOnline && (
          <span className="absolute -bottom-0 -right-0 h-2 w-2 rounded-full bg-green-500" />
        )}
      </div>
      <div className={cn("relative", overlap)}>
        <div className={cn(avatarSize, "rounded-full overflow-hidden border-2 border-white")}>
          <img src={irinaImage} alt="Irina" className="w-full h-full object-cover" />
        </div>
        {showOnline && (
          <span className="absolute -bottom-0 -right-0 h-2 w-2 rounded-full bg-green-500" />
        )}
      </div>
    </div>
  );
};
